/* ============================================================================
   ACEPLORE · v2.js — Aurora behavior layer (Theme 2.0, phase 2)
   New site-wide functionality, all progressive and reduced-motion aware:
     1. Reading progress bar
     2. Back-to-top button with scroll progress ring
     3. Smart header — tucks away scrolling down, returns scrolling up
     4. Choreographed grid stagger (auto reveal delays)
     5. Add-to-cart micro-celebration (particle burst)
   No dependencies; runs after DOM parse (defer).
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches
    || document.documentElement.dataset.animations === 'false';
  var raf = window.requestAnimationFrame || function (f) { setTimeout(f, 16); };

  /* 1 · Reading progress bar ------------------------------------------------ */
  var bar = document.createElement('div');
  bar.className = 'lm-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var ticking = false;
  function progress() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - innerHeight;
    var p = max > 0 ? Math.min(1, scrollY / max) : 0;
    bar.style.transform = 'scaleX(' + p + ')';
    if (topBtn) {
      topBtn.classList.toggle('is-shown', scrollY > 900);
      topBtn.style.setProperty('--ring', Math.round(p * 360) + 'deg');
    }
    ticking = false;
  }

  /* 2 · Back to top ---------------------------------------------------------- */
  var topBtn = document.createElement('button');
  topBtn.type = 'button';
  topBtn.className = 'lm-top';
  topBtn.setAttribute('aria-label', 'Back to top');
  topBtn.innerHTML =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  topBtn.addEventListener('click', function () {
    scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  document.body.appendChild(topBtn);

  /* 3 · Smart header --------------------------------------------------------- */
  var header = document.querySelector('.lm-header--sticky');
  var lastY = scrollY;
  var downAcc = 0;
  function smartHeader() {
    if (!header) return;
    var y = scrollY;
    var delta = y - lastY;
    lastY = y;
    // Never tuck near the top, while a menu/search inside is open, or focused.
    var busy =
      y < 160 ||
      header.matches(':focus-within') ||
      header.querySelector('.is-open, [aria-expanded="true"]');
    if (busy) {
      downAcc = 0;
      header.classList.remove('lm-header--tucked');
      return;
    }
    if (delta > 0) {
      downAcc += delta;
      if (downAcc > 90) header.classList.add('lm-header--tucked');
    } else if (delta < -4) {
      downAcc = 0;
      header.classList.remove('lm-header--tucked');
    }
  }

  addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        raf(function () {
          progress();
          smartHeader();
        });
      }
    },
    { passive: true }
  );
  progress();

  /* 4 · Choreographed grid stagger ------------------------------------------ */
  // Give sibling reveal items an incremental delay when the author didn't.
  document
    .querySelectorAll('.lm-product-grid, [data-stagger], .lm-logo-list__grid')
    .forEach(function (grid) {
      var items = grid.querySelectorAll(':scope > .lm-reveal:not([data-reveal-delay]), :scope > * > .lm-reveal:not([data-reveal-delay])');
      items.forEach(function (el, i) {
        el.dataset.revealDelay = String(Math.min(i % 8, 6) * 55);
      });
    });

  /* 5 · Add-to-cart micro-celebration ---------------------------------------- */
  function burst(x, y) {
    if (reduceMotion) return;
    var host = document.createElement('div');
    host.className = 'lm-burst';
    host.style.left = x + 'px';
    host.style.top = y + 'px';
    for (var i = 0; i < 10; i++) {
      var p = document.createElement('i');
      var a = (Math.PI * 2 * i) / 10 + Math.random() * 0.6;
      var d = 34 + Math.random() * 26;
      p.style.setProperty('--dx', Math.cos(a) * d + 'px');
      p.style.setProperty('--dy', Math.sin(a) * d - 18 + 'px');
      p.style.animationDelay = Math.random() * 40 + 'ms';
      host.appendChild(p);
    }
    document.body.appendChild(host);
    setTimeout(function () { host.remove(); }, 900);
  }
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[name="add"], [data-sticky-add], [data-quick-add], .lm-quick-add');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var r = btn.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
    },
    { passive: true }
  );
})();
